import { Component, OnInit } from '@angular/core';
import { Menu } from './menu';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ToolsService } from '../@core/services/tools.service';
import { combineLatest } from 'rxjs';

const pages =
    `<div>
    <app-header></app-header>
    <div class="container-fluid main-container">
        <div class="row min-vh-100 cdn-top">
            <aside *ngIf="expand" class="col-12 col-lg-3 d-lg-block d-block p-0">
                <app-sidebar [menu]="menu"></app-sidebar>
            </aside>
            <main class="p-0" [ngClass]="{'col-12 col-lg-9': expand, 'col-12': !expand}" id="main__content">
                <div class="scroll-main cdn-scroll-dark scroll-light-govco">
                    <div class="page__content">
                        <router-outlet></router-outlet>
                            <div *ngIf="showStyleSection">
                                <hr>
                                <h3>Estilos</h3>
                                <p>Encuentre aquí los estilos del componente.</p>
                                <a target="_blank" href="{{cssHref}}" class="btn btn-round btn-high" >Abrir</a>
                                <a *ngIf="!noDownload" target="_blank" href="{{cssHref}}" class="btn btn-round btn-high" download>Descargar</a>
                            </div>
                    </div>
                </div>
            </main>
        </div>
    </div>
    <app-footer></app-footer>
</div>
<app-modal></app-modal>`
const implement = `<router-outlet></router-outlet>
<app-modal></app-modal>`

@Component({
    selector: 'app-pages',
    template: '/pages/implementacion' === window.location.pathname ? implement : pages,
})

export class PagesComponent implements OnInit {

    menu: any[];
    expand: any;
    media: any;
    cssHref: any;
    showStyleSection: boolean = false;
    noDownload = false;
    constructor(private tools: ToolsService, private router: Router) {
        this.menu = Menu;

        this.tools.$collapseStatus.subscribe((status: any) => {
            this.expand = status;
        })

        this.tools.$mediaQuery920.subscribe((mediaquery: any) => {
            this.media = mediaquery;
            this.tools.expand();
        })
    }
    ngOnInit() {
        combineLatest(
            this.router.events.pipe(filter(event => event instanceof NavigationStart)),
            this.tools.$menu,
        ).subscribe(([router, toolsMenu]: any) => {
            window.utils.scrollToTopCDN('.scroll-main');
            if (typeof toolsMenu.css !== 'undefined') {
                this.showStyleSection = true;
                this.cssHref = `assets/cdn/css${toolsMenu.css}`;
                this.noDownload = toolsMenu.noDownload;
            } else {
                this.showStyleSection = false;
            }
        })
    }
    ngAfterViewInit() {
        if ('/pages/inicio' !== window.location.pathname) {
            this.showStyleSection = true;
            const actually = this.tools.search(this.menu, window.location.pathname.substr(1, (window.location.pathname).length), 'recursos');
            if (typeof (actually[0][0]) !== 'undefined') {
                this.cssHref = `assets/cdn/css${(actually[0][0]).recursos[0].css}`;
                this.noDownload = (actually[0][0]).recursos[0].noDownload;
            }
        }
    }

}
